import FunctionalEventPort from "./FunctionalEventPort";
import FunctionalEventPortValue from "./FunctionalEventPortValue";
import {mxCell, mxConstants, mxGeometry, mxPoint} from "mxgraph-js";

class FunctionalEventFailurePort extends FunctionalEventPort {

  constructor() {
    super(null, new FunctionalEventPortValue());
  }

  getMyGeometry(): mxGeometry {
    const g = super.getMyGeometry();
    g.offset = new mxPoint(-FunctionalEventPort.SHAPE.WIDTH / 2 + 0.5, -FunctionalEventPort.SHAPE.HEIGHT / 2);
    g.x = 0.5;
    g.y = 1;
    return g;
  }

  getMyStyle(): { [p: string]: any } {
    const style = super.getMyStyle();
    style[mxConstants.STYLE_FILLCOLOR] = 'rgba(202,91,48,0.50)';
    style[mxConstants.STYLE_STROKECOLOR] = 'rgba(202,67,65,0.70)';
    return style;
  }

  clone(): mxCell {
    throw new Error("Cannot clone");
  }
}

export default FunctionalEventFailurePort;
